import { createContext, useContext, useState, useEffect, useCallback } from "react";
import { api } from "./api";

const SiteCtx = createContext({ loaded: false, settings: {}, volume: {}, flags: {} });

export function SiteProvider({ children }) {
  const [data, setData] = useState(null);
  const load = useCallback(async () => {
    const r = await api.get("/public/site");
    setData(r.data);
  }, []);
  useEffect(() => {
    load().catch(() => setData({ settings: {}, volume: {}, flags: {} }));
  }, [load]);
  const value = {
    loaded: !!data,
    settings: data?.settings || {},
    volume: data?.volume || {},
    flags: data?.flags || {},
    refresh: load,
  };
  return <SiteCtx.Provider value={value}>{children}</SiteCtx.Provider>;
}

export const useSite = () => useContext(SiteCtx);
